import AppSettings from "Settings/AppSettings";
import ServiceWrapper from "Services/ServiceWrapper";
import AuthManager from "Common/AuthManager";

const apiBaseUrl = AppSettings.GMS_BACKEND_API_URL;

export const uploadStatus = async (jobId: string) => {
    try {
        if (jobId) {
            const response = await ServiceWrapper.doGet(
                apiBaseUrl + "job/status/" + jobId,
                null,
                null,
                AuthManager.getGmsToken()
            );
            return response?.data;
        } 
    } catch (error) {
        console.error("uploadStatus ~ error:", error);
        return null;
    }
}